import { Check } from "lucide-react";

export default function StepProgress({ currentStep, language, stepLabels }) {
  return (
    <div className="rounded-t-2xl border-b border-white/10 bg-gradient-to-r from-cyan-500 to-blue-600 px-4 py-4 shadow-xl sm:px-6">
      <div className="mx-auto flex max-w-4xl items-center justify-between text-white/90">
        {[1, 2, 3, 4, 5].map((step) => (
          <div key={step} className="flex flex-col items-center">
            <div className="flex items-center">
              <div
                className={`flex h-9 w-9 sm:h-10 sm:w-10 items-center justify-center rounded-full font-semibold transition-all ${
                  currentStep === step
                    ? "scale-110 bg-gradient-to-r from-cyan-400 to-blue-500 text-white shadow-xl ring-2 ring-white/50"
                    : currentStep > step
                    ? "bg-gradient-to-r from-cyan-500 to-blue-600 text-white shadow-lg"
                    : "bg-white/10 text-white/80"
                }`}
              >
                {currentStep > step ? <Check className="h-4 w-4" /> : step}
              </div>
              {step < 5 && (
                <div
                  className={`mx-1 h-1 w-5 rounded sm:w-16 ${
                    currentStep > step ? "bg-gradient-to-r from-cyan-500 to-blue-600" : "bg-white/10"
                  }`}
                />
              )}
            </div>
            <div
              className={`mt-1 whitespace-nowrap text-[11px] sm:text-xs ${
                currentStep === step ? "text-white font-semibold" : "text-white/80"
              }`}
            >
              {stepLabels[step][language]}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
